var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer_4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,11.68v3.1H4.67V12.47L1,8.78a1.37,1.37,0,0,1-.2-.26A1.33,1.33,0,0,1,.5,7.7V1.51A1.35,1.35,0,0,1,1.85.17h.29A1.35,1.35,0,0,1,3.48,1.51V7L6.17,9.65h6.67A1.89,1.89,0,0,1,14.5,11.68Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.73,
    cy: 5.16,
    r: 3.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer2);
export default __webpack_public_path__ + "static/media/offer2.19081696fa20557b91dba76d97b212cd.svg";
export { ForwardRef as ReactComponent };